<template>
  <header class="page-header" role="banner">
    <!-- we need this logo when user switches to nav-function-top -->
    <div class="page-logo">
      <router-link to="/dashboard">
        <img
          src="img/logo.png"
          alt="furukawa logo"
          aria-roledescription="logo"
        />
      </router-link>
      <span class="page-logo-text mr-1" style="color: #073190">
        フュージョンアウトドア 業務管理システム
      </span>
      <span
        class="position-absolute text-white opacity-50 small pos-top pos-right mr-2 mt-n2"
      ></span>
    </div>
    <!-- DOC: nav menu layout change shortcut -->
    <div class="hidden-md-down dropdown-icon-menu position-relative">
      <a
        href="#"
        class="header-btn btn js-waves-off"
        data-action="toggle"
        data-class="nav-function-hidden"
        title="Hide Navigation"
      >
        <i class="ni ni-menu"></i>
      </a>
      <ul>
        <li>
          <a
            href="#"
            class="btn js-waves-off"
            data-action="toggle"
            data-class="nav-function-minify"
            title="Minify Navigation"
          >
            <i class="ni ni-minify-nav"></i>
          </a>
        </li>
        <li>
          <a
            href="#"
            class="btn js-waves-off"
            data-action="toggle"
            data-class="nav-function-fixed"
            title="Lock Navigation"
          >
            <i class="ni ni-lock-nav"></i>
          </a>
        </li>
      </ul>
    </div>
    <!-- DOC: mobile button appears during mobile width -->
    <div class="hidden-lg-up">
      <a
        href="#"
        class="header-btn btn press-scale-down"
        data-action="toggle"
        data-class="mobile-nav-on"
      >
        <i class="ni ni-menu"></i>
      </a>
    </div>

    <div class="ml-auto d-flex">
      <div>
        <button
          type="button"
          class="btn btn-light waves-effect waves-themed"
          @click="showModal4logout()"
        >
          ログアウト
        </button>
      </div>
    </div>
  </header>
  <!-- ログアウトモーダル -->
  <Mo_modal_alert ref="Mo_modal_logout">
    <template v-slot:title>
      <i class="fal fa-check-circle text-success mr-2"></i>
      <span class="text-success fw-500"
        >ログアウトします。よろしいですか？</span
      >
    </template>
    <template v-slot:body><br /></template>
    <template v-slot:footer>
      <div class="modal-footer">
        <button
          @click="logout()"
          type="button"
          class="btn btn-danger shadow-0 bootbox-accept"
        >
          はい</button
        ><button
          @click="closeModal4logout()"
          type="button"
          class="btn btn-default bootbox-cancel"
        >
          いいえ
        </button>
      </div>
    </template>
  </Mo_modal_alert>
  <!-- ログアウトモーダル -->
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { Cl_staffImple } from "../../functions/Cl_staffImple";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";

@Options({
  components: {
    Mo_modal_alert,
  },
})
export default class Tm_header extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  //----------------------
  //モーダル用プロパティ
  //----------------------
  //----------------------
  //制御用メソッド
  //----------------------
  //----------------------
  //基本操作用メソッド
  //----------------------
  async logout() {
    await Cl_staffImple.signOut(this.$store);
  }
  //----------------------
  //モーダル用メソッド
  //----------------------
  async showModal4logout(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_logout;
    modal.showModal();
  }
  async closeModal4logout(): Promise<void> {
    const modal: any = this.$refs.Mo_modal_logout;
    modal.closeModal();
  }
}
</script>

<style scoped>
.page-logo img {
  width: 70px;
  height: auto;
}
</style>
